import React from 'react';
import { Col, Row } from "antd";
import { useRequest } from 'ahooks';
import { api } from "@redux/api";
import basicStyle from "@assets/styles/constants.js";
import DashboardCard from './DashbordCard';
import { useAuth } from '@/hooks/use-auth';
import { useSelector } from 'react-redux';
import { chartIdDashBordMappings } from '@/containers/PdfReport/template/dashboard/dashboard-chart';

const NoPermissionCard = () => {
    return <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#fff', borderRadius: '8px' }}>No permission</div>
}

const DashboardCards = () => {
    const { rowStyle } = basicStyle;
    const gasPermission = useAuth('gas', 1);
    const electricityPermission = useAuth('electricity', 1);
    const facilityId = useSelector(state => state?.Facility?.selected?.Id);

    // 分别获取电力和燃气数据
    const { data: electricityData } = useRequest(
        () => api.getElecComparision(),
        {
            ready: electricityPermission,
            cacheKey: `electricity-comparison-data-${facilityId}`,
            staleTime: 1 * 60 * 1000, // 1分钟缓存
        }
    );

    const { data: gasData } = useRequest(
        () => api.getGasComparision(),
        {
            ready: gasPermission,
            cacheKey: `gas-comparison-data-${facilityId}`,
            staleTime: 1 * 60 * 1000, // 1分钟缓存
        }
    );

    // 从API数据中提取电力和燃气数据
    const electricityResponse = electricityData?.data;
    const gasResponse = gasData?.data;

    const colCardLayout = {
        xxl: 6,
        xl: 6,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24,
        className: 'my-4',
        style: {
            padding: '4px',
            width: '100%',
            minHeight: 200
        }
    };

    return (
        <Row style={rowStyle} gutter={8} justify="start" className={''}>
            <Col {...colCardLayout} className={chartIdDashBordMappings.cards[0]}>
            {gasPermission ? <DashboardCard

                    title="Electricity Monthly Consumption"
                    value={Math.round(Number(electricityResponse?.electricity?.latest_consumption || 0)).toLocaleString()}
                    unit="kWh"
                    percent={electricityResponse?.electricity?.consumption_diff ? `${Number(electricityResponse.electricity.consumption_diff * 100).toFixed(2)}%` : "0.00%"}
                    startDate={electricityResponse?.electricity?.latest_service_month ? new Date(electricityResponse.electricity.latest_service_month).toLocaleDateString('en-US', { year: 'numeric', month: 'short' }) : 'N/A'}
                    endDate={electricityResponse?.electricity?.last_service_month ? new Date(electricityResponse.electricity.last_service_month).toLocaleDateString('en-US', { year: 'numeric', month: 'short' }) : 'N/A'}
                    isIncreased={Number(electricityResponse?.electricity?.consumption_diff) > 0}
                    variant="blue"
                /> : <NoPermissionCard />}
            </Col>
            
            <Col {...colCardLayout} className={chartIdDashBordMappings.cards[1]}>
                {electricityPermission ? <DashboardCard
                    title="Electricity Monthly Cost"
                    value={`$${Math.round(Number(electricityResponse?.electricity?.latest_cost || 0)).toLocaleString()}`}
                    unit=""
                    percent={electricityResponse?.electricity?.cost_diff ? `${Number(electricityResponse.electricity.cost_diff * 100).toFixed(2)}%` : "0.00%"}
                    startDate={electricityResponse?.electricity?.latest_service_month ? new Date(electricityResponse.electricity.latest_service_month).toLocaleDateString('en-US', { year: 'numeric', month: 'short' }) : 'N/A'}
                    endDate={electricityResponse?.electricity?.last_service_month ? new Date(electricityResponse.electricity.last_service_month).toLocaleDateString('en-US', { year: 'numeric', month: 'short' }) : 'N/A'}
                    isIncreased={Number(electricityResponse?.electricity?.cost_diff) > 0}
                    variant="green"
                /> : <NoPermissionCard />}
            </Col>
            
            <Col {...colCardLayout} className={chartIdDashBordMappings.cards[2]}>
                {gasPermission ? <DashboardCard
                    title="Gas Monthly Consumption"
                    value={Math.round(Number(gasResponse?.gas?.latest_consumption || 0)).toLocaleString()}
                    unit="MMBtu"
                    percent={gasResponse?.gas?.consumption_diff ? `${Number(gasResponse.gas.consumption_diff * 100).toFixed(2)}%` : "0.00%"}
                    startDate={gasResponse?.gas?.latest_service_month ? new Date(gasResponse.gas.latest_service_month).toLocaleDateString('en-US', { year: 'numeric', month: 'short' }) : 'N/A'}
                    endDate={gasResponse?.gas?.last_service_month ? new Date(gasResponse.gas.last_service_month).toLocaleDateString('en-US', { year: 'numeric', month: 'short' }) : 'N/A'}
                    isIncreased={Number(gasResponse?.gas?.consumption_diff) > 0}
                    variant="purple"
                /> : <NoPermissionCard />}
            </Col>
            
            <Col {...colCardLayout} className={chartIdDashBordMappings.cards[3]}>
                {gasPermission ? <DashboardCard
                    title="Gas Monthly Cost"
                    value={`$${Math.round(Number(gasResponse?.gas?.latest_cost || 0)).toLocaleString()}`}
                    unit=""
                    percent={gasResponse?.gas?.cost_diff ? `${Number(gasResponse.gas.cost_diff * 100).toFixed(2)}%` : "0.00%"}
                    startDate={gasResponse?.gas?.latest_service_month ? new Date(gasResponse.gas.latest_service_month).toLocaleDateString('en-US', { year: 'numeric', month: 'short' }) : 'N/A'}
                    endDate={gasResponse?.gas?.last_service_month ? new Date(gasResponse.gas.last_service_month).toLocaleDateString('en-US', { year: 'numeric', month: 'short' }) : 'N/A'}
                    isIncreased={Number(gasResponse?.gas?.cost_diff) > 0}
                    variant="orange"
                /> : <NoPermissionCard />}
            </Col>
        </Row>
    );
};

export default DashboardCards;
